<div class="announcement-popup animated fadeInUpBig" id="announcementDetail">
  <div class="announcement-header">
    <a href="javascript:void(0);" class="ah-left-image">
      <img src="{{AnnouncementSummary['Thumbnail']}}" style="width: 50px; height: 48px;" alt="{{bs.getResource('rbkey_AnncntDtlThmnlImgLBL')}}" *ngIf="AnnouncementSummary['Thumbnail']!=''"
        class="assets/img-icon" >
      <img src="assets/img/horn-image.jpg" style="width: 50px; height: 48px;" alt="{{bs.getResource('rbkey_AnncntDtlHrnImgLBL')}}" *ngIf="AnnouncementSummary['Thumbnail']==''"
        class="assets/img-icon">


      <span class="image-heading spanCustomClass">{{AnnouncementSummary['DetailedTitle'] | escape}}</span>
    </a>
    <a href="javascript:void(0);" class="ah-close" (click)="closeAnnouncementDetail()">
      <img src="assets/img/cross-icon.png" alt="{{bs.getResource('rbkey_AnncntDtlClsImgLBL')}}">
    </a>
  </div>

  <div id="app-chat" role="tabpanel" class="tab-pane fade show active in">
    <div class="announcement-inner">
      <div class="announcement-popup-inner" style="padding: 20px 0px 60px;">
        <div class="announcement-tab-list">
          <div class="{{ClassName}}">
            <div class="atl-box-top">

              <div class="atl-left-block">
                <div class="atlr-top-name">
                  <span class="spanClass">{{bs.getResource('rbkey_DscrptnLBL')}}</span>
                </div>
                <div class="announcement-description">
                  <span [innerHtml]="AnnouncementSummary['DetailedDescription']">
                  </span>
                </div>
                <a href="javascript:void(0);" class="data-image-sec">
                  <a href="{{AnnouncementSummary['Attachment']}}" target="_blank" *ngIf="AnnouncementSummary['AttachmentName']!=''">
                    <span>{{AnnouncementSummary['AttachmentName']}}</span>
                  </a>
                </a>
                <div class="atl-right-position">
                  <div class="atl-right-inner" >
                    <a href="javascript:void(0);"  class="{{BookClassName}}" (click)="readAnnouncement(AnnouncementSummary['AnnoncementId'], AnnouncementSummary['IsRead'], AnnouncementSummary['IsAcknowledgementRequired'])"></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="atl-box-bottom">
              <ul class="atl-bottom-list">
                <li>
                  <div class="head">{{bs.getResource('rbkey_Crtr_LBL')}}</div>
                  <div class="subhead">{{AnnouncementSummary['CreatedBy']}}</div>
                </li>
                <li>
                  <div class="head">{{bs.getResource('rbkey_AvltyLBL')}}</div>
                  <div class="subhead">{{AnnouncementSummary['Availabilty']}}</div>
                </li>
                <li>
                  <div class="head">{{bs.getResource('rbkey_TimeAndDateLBL')}}</div>
                  <div class="subhead">{{AnnouncementSummary['CreationDate']}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-esign [scope]="'NtfctnAnnDtl'" (acceptClick)="AcknowledgeEsign($event)" ></app-esign>
</div>